import { Component, Input } from '@angular/core';

@Component({
    template: '',
    standalone: false
})
export class GridPanelComponent
{
    @Input() withBorder: boolean = false;
    @Input() whiteBackground: boolean = false;
    @Input() classes: string = '';
}
